import html2canvas from 'html2canvas';
import { generatePdf } from './generatePdf';
import {
  darkModeDiagramBackgroundColor,
  lightModeDiagramBackgroundColor,
  exportImageScaleFactor,
  headerBackgroundColor,
} from './constants';
import { determineCurrentTheme } from './utils';

export const exportPdf = async ({
  size,
  orientation,
  name,
}: Pick<ExportFormFields, 'size' | 'orientation' | 'name'>): Promise<void> => {
  const currentTheme = determineCurrentTheme();

  const canvas = await html2canvas(
    document.getElementById('canvas') as HTMLElement,
    {
      backgroundColor:
        currentTheme === 'light'
          ? lightModeDiagramBackgroundColor
          : darkModeDiagramBackgroundColor,
      scale: exportImageScaleFactor,
      useCORS: true,
    },
  );

  const ciscoLogo = await html2canvas(
    document.getElementById('header-cisco-logo') as HTMLElement,
    {
      backgroundColor: headerBackgroundColor,
      scale: exportImageScaleFactor,
      useCORS: true,
    },
  );

  const canvasDataUrl = canvas.toDataURL('image/png');
  const ciscoLogoDataUrl = ciscoLogo.toDataURL('image/png');

  const pdf = generatePdf({
    canvas,
    canvasDataUrl,
    ciscoLogoDataUrl,
    name,
    orientation,
    size,
  });

  pdf.save('diagram-export');
};
